export default {
  bind(el, binding, vnode) {
    const vm = vnode.context;

    const fetchImage = async (url) => {
      if (!url) {
        el.src = null; // Путь к дефолтной аватарке
        return;
      }

      try {
        // Делаем запрос через vm.$http, запуская глобальные интерцепторы
        const response = await vm.$http.get(url, { responseType: 'blob' });
        const blob = response.body || response.data;
        const blobUrl = URL.createObjectURL(blob);

        if (el._currentBlobUrl) {
          URL.revokeObjectURL(el._currentBlobUrl);
        }
        el._currentBlobUrl = blobUrl;
        el.src = blobUrl;
      } catch (error) {
        console.error('Ошибка загрузки защищенного изображения:', error);
        el.src = null; // Заглушка при ошибке
      }
    };

    el._fetchImage = fetchImage;
    fetchImage(binding.value);
  },

  update(el, binding) {
    if (binding.value !== binding.oldValue) {
      el._fetchImage(binding.value);
    }
  },

  unbind(el) {
    if (el._currentBlobUrl) {
      URL.revokeObjectURL(el._currentBlobUrl);
    }
  }
};